'use client';

// Main exports for client-side usage
export { CosmicAnalyticsProvider } from './client/CosmicAnalyticsProvider';
export { useCosmicAnalytics, initAnalytics, getAnalytics } from './client/useCosmicAnalytics';

// Core class export for advanced usage
export { CosmicAnalytics } from './lib/analytics';

// Type exports
export type {
  AnalyticsConfig,
  AnalyticsEvent,
  PageViewEvent,
  PageExitEvent,
  DeviceInfo,
  AnalyticsMetrics,
} from './types';

// Utility exports
export {
  parseUserAgent,
  getReferrerSource,
  isBrowser,
} from './lib/utils'; 